import angular from 'angular';
import revokeGiftOrderDialogComponent from './revoke.gift.order.dialog.component';
export default angular.module('inv.customer.orderHistory.revokeGiftOrderDialog', []).component('revokeGiftOrderDialog', revokeGiftOrderDialogComponent).name;